import React, { useEffect, useState } from "react";
import { formatDate, toInputDate } from "../utils/helpers";

const displayDatePattern = /^(\d{2})-(\d{2})-(\d{4})$/;

const toIsoFromDisplay = (value) => {
  const match = String(value || "").trim().match(displayDatePattern);
  if (!match) {
    return "";
  }
  return `${match[3]}-${match[2]}-${match[1]}`;
};

function DateInput({ value, onChange, name, placeholder = "dd-mm-yyyy", ...props }) {
  const [displayValue, setDisplayValue] = useState(value ? formatDate(value) : "");

  useEffect(() => {
    setDisplayValue(value ? formatDate(value) : "");
  }, [value]);

  const emitChange = (nextValue) => {
    if (!onChange) {
      return;
    }

    onChange({
      target: {
        name,
        value: nextValue
      }
    });
  };

  const handleChange = (event) => {
    const nextDisplayValue = event.target.value;
    setDisplayValue(nextDisplayValue);

    if (!nextDisplayValue) {
      emitChange("");
      return;
    }

    const isoValue = toIsoFromDisplay(nextDisplayValue);
    if (isoValue) {
      emitChange(isoValue);
    }
  };

  const handleBlur = () => {
    const isoValue = toIsoFromDisplay(displayValue);
    if (displayValue && !isoValue) {
      setDisplayValue(value ? formatDate(value) : "");
      return;
    }

    if (isoValue) {
      setDisplayValue(formatDate(toInputDate(displayValue)));
    }
  };

  return (
    <input
      {...props}
      name={name}
      type="text"
      inputMode="numeric"
      placeholder={placeholder}
      value={displayValue}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  );
}

export default DateInput;
